var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-collection-card',{attrs:{"title":"Customers who bought Product1 and Product2","subtitle":"(anytime)","data":_vm.customers,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }